import http from "../utils/http";
import { toast } from "react-toastify";
import { store } from "../store";
import { removeLoader, setLoader } from "../redux/actions/loader";

export const get_tarifas = async (
  sector_type,
  tarifa_oferta,
  mode_facturacio,
  first_name,
  type_oferta,
) => {
  try {
    store.dispatch(setLoader("Obteniendo Tarifas"));
    const res = await http.get(`/erp/tarifas/${sector_type}`, {
      params: { tarifa_oferta, mode_facturacio, first_name, type_oferta },
    });
    if (res.status === 200) {
      res.data.tarifas_erp.unshift({ id: 0, value: "", name: "Seleccione la tarifa" });
      return res.data.tarifas_erp;
    } else {
      toast.info("No hay tarifas disponibles.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2500,
      });
    }
  } catch (err) {
    const mensaje = err.response.data.error;
    toast.error(mensaje, {
      position: toast.POSITION.TOP_CENTER,
    });
  } finally {
    store.dispatch(removeLoader());
  }
};

export const get_sub_type_offer = async (sector_type, offer_type) => {
  try {
    store.dispatch(setLoader("Obteniendo subtipos de oferta"));
    const res = await http.get(`/erp/tarifas/${sector_type}`, {
      params: { offer_type }  // Solo pasar offer_type como param
    });

    if (res.status === 200) {
      return res.data;
    } else {
      toast.info("No hay subtipos disponibles.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return { subtypes_offer_options: [] }; // Devolver estructura esperada
    }
  } catch (err) {
    const mensaje = err.response?.data?.error || "Error al obtener subtipos";
    toast.error(mensaje, {
      position: toast.POSITION.TOP_CENTER,
    });
    return { subtypes_offer_options: [] }; // Devolver estructura esperada incluso en error
  } finally {
    store.dispatch(removeLoader());
  }
};